import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { createUser } from "../services/auth";
import { CreateUser } from "../types";
import useAuth from "./useAuth";
import useGetUserData from "./useGetUserData";
import * as Sentry from "@sentry/react";

export default function useCreateUser(
  options: UseMutationOptions<void, Error, CreateUser, unknown>,
) {
  const { user } = useAuth();
  const { refetch } = useGetUserData();

  return useMutation({
    mutationFn: async ({ name, place }: CreateUser) => {
      if (!user) {
        throw new Error("User not logged in");
      }

      try {
        await createUser(place.position, place.name, name);

        await refetch();
      } catch (error) {
        Sentry.captureException(error);
        throw error;
      }
    },
    ...options,
  });
}
